
import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Aboutpage from './components/pages/Aboutpage';
import Menupage from './components/pages/Menupage';
import Contactus from './components/pages/Contactus';
import Foodpage from './components/pages/Foodpage';
import Mission from './components/pages/Mission';
import Vision from './components/pages/Vision';
import Gallerypage from './components/pages/Gallerypage';
import Birthday from './components/pages/Birthday';
import Engagement from './components/pages/Engagement';
function App() {
  return (
    <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
          <Route axact path="/aboutus" element={<Aboutpage/>} />
           <Route axact path="/menu" element={<Menupage/>} />
              <Route axact path="/contactus" element={<Contactus/>} />
                <Route axact path="/mission" element={<Mission/>} />
                   <Route axact path="/vision" element={<Vision/>} />
                          <Route axact path="/gallery" element={<Gallerypage/>} />
                            <Route axact path="/weddingevent" element={<Engagement/>} />
                                   <Route axact path="/birthday-party" element={<Birthday/>} />
                           <Route axact path="/food" element={<Foodpage/>} />
              </Routes>
        <Footer />

      </div>

    </Router>
  );
}

export default App;
